export default __webpack_public_path__ + "static/media/4689@3x.b9719106.png";